import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';

function PlayerTypeButton() {
    const location = useLocation();

    const locationSplit = location['pathname'].split('/');
    const leagueType = locationSplit[1];
    const playerType = locationSplit[2];
    const playerId = locationSplit[3];

    function playerTypeCalc(btnType) {
        if(btnType === "batter" && playerType === "batter") {
            return 'active';
        } else if(btnType === "pitcher" && playerType === "pitcher") {
            return 'active';
        } else {
            return '';
        }
    }

    function playerTypeClickEventHandler(event) {
        let playerValue = event.target.value;

        if(playerValue !== playerType) {
            window.location.href = `/${leagueType}/${playerValue}/${playerId}`;
        }
    }

    return (
        <>
        <ButtonGroup aria-label="Basic example" style={{float: 'left', marginLeft: '5px'}}>
            <Button 
            variant="secondary" size="sm" value="batter" 
            active={playerTypeCalc("batter")}
            onClick={playerTypeClickEventHandler}>타자</Button>
            <Button 
            variant="secondary" size="sm" value="pitcher" 
            active={playerTypeCalc("pitcher")}
            onClick={playerTypeClickEventHandler}>투수</Button>
        </ButtonGroup>
        </>
    )   
}

export default PlayerTypeButton;